import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../images/hero-bg.png';
import bannerImg from '../images/EGB React project images/06/cropped-colibri-image-28-1.png';
import merrillLogo from '../images/clients/merrill-lynch.png';
import amexLogo from '../images/clients/american-express.jpg';
import nestleLogo from '../images/clients/nestle.png';
import upsLogo from '../images/clients/ups.png';
import nyseLogo from '../images/clients/nyse.png';
import ubsLogo from '../images/clients/ubs.png';
import pepsiLogo from '../images/clients/pepsico.png';
import nokiaLogo from '../images/clients/nokia.png';
import verizonLogo from '../images/clients/verizon.png';
import metlifeLogo from '../images/clients/metlife.png';
import jpmorganLogo from '../images/clients/jpmorgan.png';

const services = [
  { icon: '💻', title: 'Software Development', description: 'Custom software solutions tailored to your business needs.' },
  { icon: '☁️', title: 'Cloud Solutions', description: 'Migrate your business to the cloud with comprehensive services.' },
  { icon: '🔒', title: 'Cybersecurity', description: 'Protect your business with advanced security solutions.' },
  { icon: '📱', title: 'Mobile Development', description: 'Native and cross-platform mobile applications.' },
  { icon: '📊', title: 'Data Analytics', description: 'Transform data into actionable insights.' },
  { icon: '⚙️', title: 'IT Consulting', description: 'Strategic IT consulting for informed decisions.' },
];

const clients = [
  { name: 'Merrill Lynch', logo: merrillLogo },
  { name: 'American Express', logo: amexLogo },
  { name: 'Nestlé', logo: nestleLogo },
  { name: 'UPS', logo: upsLogo },
  { name: 'NYSE', logo: nyseLogo },
  { name: 'UBS', logo: ubsLogo },
  { name: 'PepsiCo', logo: pepsiLogo },
  { name: 'JPMorgan Chase', logo: jpmorganLogo },
  { name: 'Avon', logo: null },
  { name: 'Nokia', logo: nokiaLogo, color: '#005AFF' },
  { name: 'Verizon', logo: verizonLogo, color: '#CD040B' },
  { name: 'MetLife', logo: metlifeLogo, color: '#0066CC' },
  { name: 'Vikram Chatwal Hotels', logo: null },
  { name: 'YMCA', logo: null },
  { name: 'Coach', logo: null },
];

const Home = () => (
  <>
    {/* Hero */}
    <section className="text-white py-5" style={{ background: `url(${heroBg}) center/cover no-repeat`, minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <div className="container py-5">
        <div className="row align-items-center g-5">
          <div className="col-12 col-lg-7">
            <span className="badge bg-warning text-dark mb-3 px-3 py-2">ISO 9001:2000 · GSA Contract · INC 500 #213</span>
            <h1 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', whiteSpace: 'nowrap', color: '#ffffff', textShadow: '0 2px 8px rgba(0,0,0,0.6)' }}>EGB Systems &amp; Solutions, Inc.</h1>
            <p className="lead mb-4" style={{ color: '#ffffff', textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>Banking, Healthcare, IT, Telecom, Education, Hospitality, Government — comprehensive solutions across every industry domain.</p>
            <div className="d-flex flex-wrap gap-3">
              <Link to="/services" className="btn btn-warning btn-lg fw-bold">Explore Services →</Link>
              <Link to="/contact" className="btn btn-outline-light btn-lg">Get a Quote</Link>
            </div>
          </div>
          <div className="col-12 col-lg-5">
            <img src={bannerImg} alt="EGB Banner" style={{ width: '100%', borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }} />
          </div>
        </div>
      </div>
    </section>

    {/* Services */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-2">WHAT WE OFFER</span>
          <h2 className="fw-bold">Our Core Services</h2>
          <p className="text-muted">Comprehensive end-to-end solutions for businesses of all sizes.</p>
        </div>
        <div className="row g-4">
          {services.map((s, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm p-3">
                <div className="card-body">
                  <div style={{ fontSize: 36 }} className="mb-3">{s.icon}</div>
                  <h5 className="fw-bold">{s.title}</h5>
                  <p className="text-muted small">{s.description}</p>
                  <Link to="/services" className="text-primary fw-semibold text-decoration-none small">Learn more →</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* About */}
    <section className="py-5 bg-white">
      <div className="container py-4">
        <div className="row align-items-center g-5">
          <div className="col-12 col-lg-6">
            <div className="rounded-4 d-flex align-items-center justify-content-center" style={{ height: 350, background: 'linear-gradient(135deg, #dbeafe, #e0e7ff)', fontSize: 80 }}>🏢</div>
          </div>
          <div className="col-12 col-lg-6">
            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 mb-3">ABOUT EGB</span>
            <h2 className="fw-bold mb-3">Transforming E-Business with Strategic Solutions</h2>
            <p className="text-muted">EGB offers a range of strategic business solutions. Comprehensive in structure, elaborate in execution, dynamic in style — our service portfolio provides complete end-to-end solutions.</p>
            <p className="text-muted">We provide Software Development, IT Consulting, Website Design, Internet Marketing, and Back Office Support for diverse business sectors.</p>
            <div className="d-flex gap-4 my-4">
              {[{ icon: '⚡', label: 'Fast Delivery' }, { icon: '🔒', label: 'Quality Assured' }, { icon: '💬', label: '24/7 Support' }].map(item => (
                <div key={item.label} className="text-center">
                  <div style={{ fontSize: 28 }}>{item.icon}</div>
                  <div className="small fw-semibold mt-1">{item.label}</div>
                </div>
              ))}
            </div>
            <Link to="/about" className="btn btn-primary">Learn More →</Link>
          </div>
        </div>
      </div>
    </section>

    {/* Clients */}
    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Our Happy Clients</h2>
          <p className="text-muted">Trusted by Fortune 500 companies worldwide.</p>
        </div>
        <div className="d-flex flex-wrap justify-content-center gap-4">
          {clients.map(client => (
            <div key={client.name} className="d-flex flex-column align-items-center justify-content-center bg-white border rounded-3 p-3"
              style={{ width: 160, height: 110, boxShadow: '0 2px 8px rgba(0,0,0,0.07)' }}>
              {client.logo ? (
                <img src={client.logo} alt={client.name} style={{ maxHeight: 50, maxWidth: 130, objectFit: 'contain', marginBottom: 6 }} />
              ) : (
                <div className="fw-bold mb-1" style={{ fontSize: 16, textAlign: 'center', color: client.color || '#1a56db' }}>{client.name}</div>
              )}
              <div className="text-muted" style={{ fontSize: 11, textAlign: 'center' }}>{client.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #1a56db, #0ea5e9)' }}>
      <div className="container py-4">
        <h2 className="fw-bold mb-3">Ready to Transform Your Business?</h2>
        <p className="lead mb-4">Let's build something great together.</p>
        <Link to="/contact" className="btn btn-warning btn-lg fw-bold px-5">Contact Us →</Link>
      </div>
    </section>
  </>
);

export default Home;
